import React from 'react';
import { techLogos, LOGO_VIEWBOX } from './techLogos';

function TechPartners() {
  return (
    <section className="bg-gradient-to-b from-gray-50 to-white dark:from-gray-800 dark:to-gray-900 py-10 lg:py-14" id="tech-partners">
      <div className="max-w-screen-xl px-4 mx-auto text-center">
        <p className="mb-2 text-sm font-semibold uppercase tracking-widest text-accent-600 dark:text-accent-400">
          Our Stack
        </p>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white lg:text-3xl">
          Built on{" "}
          <span className="bg-gradient-to-r from-accent-600 via-accent-400 to-accent-600 bg-clip-text text-transparent dark:from-accent-300 dark:via-accent-200 dark:to-accent-300">
            Proven Technology
          </span>
        </h2>
        <p className="mt-3 text-base text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
          Edge infrastructure, cloud, CI/CD and containers — the platforms we run every day.
        </p>

        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 sm:gap-x-10">
          {techLogos.map((logo) => (
            <li key={logo.name}>
              <svg
                className="h-20 w-auto text-gray-400 hover:text-accent-600 dark:hover:text-accent-400 transition-colors duration-300"
                viewBox={LOGO_VIEWBOX}
                fill="currentColor"
                role="img"
                aria-label={logo.name}
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>{logo.name}</title>
                {logo.paths.map((d, i) => (
                  <path key={i} d={d} />
                ))}
              </svg>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default TechPartners;
